import { graphql } from "@/gql";

export const createRelocationPageArticleMutation = graphql(`
  mutation CreateRelocationPageArticleMutation(
    $input: CreateRelocationPageArticle!
  ) {
    createRelocationPageArticle(input: $input) {
      id
    }
  }
`);

export const deleteRelocationPageArticleMutation = graphql(`
  mutation DeleteRelocationPageArticleMutation($id: ID!) {
    deleteRelocationPageArticle(id: $id) {
      id
    }
  }
`);

export const sortRelocationPageArticleMutation = graphql(`
  mutation SortRelocationPageArticleMutation($ids: [ID!]!) {
    setRelocationPageArticleSortOrder(ids: $ids)
  }
`);
